import React, { useEffect, useState } from "react";
import "./DeviceSignalHistory.css";
import MainLayout from "components/layout/main-layout/MainLayout";
import SubscriberInformationCard from "components/layout/subscriber-information-card/SubscriberInformationCard";
import { titles } from "constants/titles";
import SignalDetailCard from "components/layout/signal-detail-card/SignalDetailCard";
import DeviceInfoModal from "components/layout/device-info-modal/DeviceInfoModal";
import EditDeviceNameModal from "components/layout/edit-device-name-modal/EditDeviceNameModal";
import {
  getDeviceSignalHistory,
  setSelectedDeviceDetails,
} from "redux/Devices/actions";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  ANELTO_DEVICE_DETAILS_SUCCESS,
  CLAIRVOYANT_DEVICE_DETAIL_SUCESS,
  EVIEW_DEVICE_DETAIL_SUCESS,
  FREEUS_DEVICE_DETAILS_SUCCESS,
} from "redux/Devices/actionTypes";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import InformationModal from "components/layout/information-modal/InformationModal";
import CustomButton from "components/widgets/custom-button/CustomButton";
import { convertInRequiredTimeZone } from "utility";
import { IconEdit, IconGPSDevice, IconQuestion } from "assets/SVGs/SVGs";

const DeviceSignalHistory = (props) => {
  const [showDeviceInfo, setShowDeviceInfo] = useState(false);
  const [showEditDeviceModal, setShowEditDeviceModal] = useState(false);
  const userData = useSelector((store) => store?.auth?.userData);
  const { selectedMedicalUser } = useSelector(
    (store) => store?.medicalAlertUsers
  );
  const {
    deviceList,
    loading,
    deviceSignalHistory,
    aneltoDeviceDetails,
    freeusDeviceDetails,
    eViewDeviceDetails,
    selectedDeviceDetails,
    deviceDetails
  } = useSelector((store) => store?.devices);

  const { currentTimeZone } = useSelector((store) => store?.common);
  const [informationModal, setInformationModal] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const isAllSignalHistory = location?.state?.isAllSignalHistory;

  useEffect(() => {
    getSignalHistory(false);
  }, []);

  const getSignalHistory = () => {
    const param = {
      dispatch,
      history,
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
      medical_alert_user_id: selectedMedicalUser
        ? selectedMedicalUser?.medical_alert_user_id
        : selectedDeviceDetails?.medical_alert_user_id,
      user_device_id: isAllSignalHistory
        ? undefined
        : selectedDeviceDetails?.user_device_id,
    };
    getDeviceSignalHistory(param);
  };

  const onDeviceProfileClick = (item) => {
    if (isAllSignalHistory) {
      const selectedDevice = deviceList?.filter(
        (device) => device?.user_device_id === item?.user_device_id
      );
      if (selectedDevice && selectedDevice?.length > 0) {
        setSelectedDeviceDetails(dispatch, selectedDevice[0]);
        redirectToDeviceProfile(item);
      }
    } else {
      //remove redirection for device signal history. will add it later if required
      // redirectToDeviceProfile()
    }
  };

  const redirectToDeviceProfile = (item) => {
    setSelectedDeviceDetails(dispatch, item);
    dispatch({
      type: ANELTO_DEVICE_DETAILS_SUCCESS,
      payload: null,
    });
    dispatch({
      type: FREEUS_DEVICE_DETAILS_SUCCESS,
      payload: null,
    });
    dispatch({
      type: CLAIRVOYANT_DEVICE_DETAIL_SUCESS,
      payload: null,
    });
    dispatch({
      type: EVIEW_DEVICE_DETAIL_SUCESS,
      payload: null,
    });
    history.push(ROUTES_CONSTANTS.deviceProfile, {
      isFromSignalHistory: true,
    });
  };

  const customSchemaForUI = () => {
    let autoFallDetection = false;
    const deviceType = selectedDeviceDetails?.device_type?.trim();
    if (deviceType === "anelto") {
      autoFallDetection =
        aneltoDeviceDetails?.is_fall_detect === 1 ? true : false;
    } else if (deviceType === "freeus") {
      autoFallDetection =
        freeusDeviceDetails?.is_fall_detect === 1 ? true : false;
    } else if (deviceType === "eview") {
      const fallDownAlert = eViewDeviceDetails?.features?.fallDownAlert;
      const fallDownStatus = eViewDeviceDetails?.generalData?.fallDownStatu;
      autoFallDetection =
        fallDownAlert === 1
          ? true
          : fallDownAlert === 0
            ? false
            : fallDownStatus === 1
              ? true
              : false;
    }
    return {
      deviceName: selectedDeviceDetails?.device_name,
      autoFallDetection: autoFallDetection, // check
      deviceId: selectedDeviceDetails?.provider_device_id,
      userDeviceId: selectedDeviceDetails?.user_device_id,
      networkProvider: deviceDetails?.network_provider,
      medicalAlertUserId: selectedDeviceDetails?.medical_alert_user_id,
    };
  };

  const renderSignalHistoryList = () => (
    <div className="dsh_signal_list">
      {deviceSignalHistory?.map((item, index) => (
        <SignalDetailCard
          key={`signal-${index}`}
          className="dsh_signal_card"
          signalData={item}
          onCardClick={onDeviceProfileClick}
        />
      ))}
    </div>
  );

  return (
    <MainLayout
      text={
        isAllSignalHistory
          ? titles?.all_signal_history
          : titles?.device_signal_history
      }
      isBackHide={false}
      isNavbar={true}
      white={true}
      primary={isAllSignalHistory ? false : true}
      isLoading={loading}
    >
      <DeviceInfoModal
        setShow={setShowDeviceInfo}
        show={showDeviceInfo}
        selectedDeviceDetails={selectedDeviceDetails}
        deviceSchema={customSchemaForUI()}
      />
      <EditDeviceNameModal
        show={showEditDeviceModal}
        setShow={setShowEditDeviceModal}
        selectedDeviceDetails={selectedDeviceDetails}
        onCancel={() => setShowEditDeviceModal(false)}
      />
      <InformationModal
        show={informationModal}
        setShow={setInformationModal}
        infoText={titles?.signal_history_tip}
      />

      {deviceSignalHistory?.length > 0 ? (
        isAllSignalHistory ? (
          <div className="dsh_container">
            {/* Subscriber Information Card */}
            {isAllSignalHistory && (
              <SubscriberInformationCard
                medicalUserDetail={selectedMedicalUser}
              />
            )}

            {/* Instructions */}
            <div className="dsh_instructions">
              <h2 className="dsh_main_instruction">
                {isAllSignalHistory
                  ? titles?.view_past_all_signals?.split(".")[0] + "."
                  : titles?.view_past_signals?.split("\n")[0]}
              </h2>
              <p className="dsh_sub_instruction">
                {isAllSignalHistory
                  ? titles?.view_past_all_signals?.split(".")[1]?.trim()
                  : titles?.view_past_signals?.split("\n")[1]?.trim()}
              </p>
            </div>

            {/* Signal History List */}
            {renderSignalHistoryList()}
          </div>
        ) : (
          <div className="dsh_device_container">
            {/* Device Profile Card */}
            <div className="dsh_device_card mb20">
              <div className="dsh_device_sub_container">
                <div className="dsh_device_image_container">
                  {selectedDeviceDetails?.image_url ? (
                    <img
                      src={selectedDeviceDetails?.image_url}
                      alt="Device"
                      className="dsh_device_image"
                    />
                  ) : (
                    <div className="dsh_device_placeholder">
                      <IconGPSDevice width="32" height="32" />
                    </div>
                  )}
                </div>
                <div className="dsh_device_description_container">
                  <h2 className="dsh_device_title">
                    {customSchemaForUI()?.deviceName}
                  </h2>
                  <p className="dsh_device_subtitle">
                    {`${selectedDeviceDetails?.firstname} ${selectedDeviceDetails?.lastname}`}
                  </p>
                  <button
                    className="dsh_about_device_link"
                    onClick={() => setShowDeviceInfo(true)}
                  >
                    {titles?.about_this_device}
                  </button>
                </div>
                <div className="dsh_edit_button_container">
                  <IconEdit
                    className="dsh_edit_icon"
                    color="#6B6B6B"
                    onClick={() => setShowEditDeviceModal(true)}
                  />
                </div>
              </div>

              <CustomButton
                text={titles?.refresh_signal}
                width="100%"
                className="dsh_refresh_button"
                onClick={() => getSignalHistory(true)}
              />

              {deviceSignalHistory &&
                deviceSignalHistory?.length > 0 &&
                deviceSignalHistory[0]?.date ? (
                <div className="dsh_last_refresh_container">
                  <p className="dsh_last_refresh_text">
                    {`${titles?.last_refresh +
                      convertInRequiredTimeZone(
                        deviceSignalHistory?.[0]?.date,
                        selectedMedicalUser?.timezone,
                        currentTimeZone
                      )
                      }`}
                  </p>
                  <IconQuestion
                    className="dsh_help_icon"
                    onClick={() => setInformationModal(true)}
                  />
                </div>
              ) : null}
            </div>
            <p className="dsh_main_instruction text-white-color new_line_text">
              {isAllSignalHistory
                ? titles?.view_past_all_signals
                : titles?.view_past_signals}
            </p>
            {/* Signal History List */}
            {renderSignalHistoryList()}
          </div>
        )
      ) : !loading ? (
        <div className={`alert_empty_message ${isAllSignalHistory ? "" : "text-white-color"}`}>
          {titles?.no_history_available}
        </div>
      ) : null}
    </MainLayout>
  );
};

export default DeviceSignalHistory;
